import Vue from "vue";
import axios from "./router/axios";
import VueAxios from "vue-axios";
import App from "./App";
import router from "./router/router";
import "./permission"; // 权限
import "./error"; // 日志
import store from "./store";
import { loadStyle } from "./util/util";
import * as urls from "@/config/env";
import Element from "element-ui";
import Avue from "@smallwei/avue";
import { iconfontUrl, iconfontVersion } from "@/config/env";
import i18n from "./lang"; // Internationalization
import "./styles/common.scss";
import "@/plugins/yi-ui.js"; // yi-ui
import "windi.css";
import directiveFun from "@/util/directive.js";

import basicContainer from "./components/basic-container/main";
import thirdRegister from "./components/third-register/main";

Vue.config.devtools = true;

Vue.use(VueAxios, axios);
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value),
});

// 使用 npm 安装的 avue
Vue.use(Avue, {
  size: "small",
  tableSize: "small",
  calcHeight: -90,
  i18n: (key, value) => i18n.t(key, value),
});
//注册全局容器
Vue.component("basicContainer", basicContainer);
Vue.component("thirdRegister", thirdRegister);
// 加载相关url地址
Object.keys(urls).forEach((key) => {
  Vue.prototype[key] = urls[key];
});

// 动态加载阿里云字体库
iconfontVersion.forEach((ele) => {
  loadStyle(iconfontUrl.replace("$key", ele));
});

Vue.config.productionTip = false;

import AvueUeditor from "avue-plugin-ueditor";
Vue.use(AvueUeditor);

window.axios = axios;

directiveFun(Vue);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
